import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import Util from '../../../Common/util';
import API from '../../../Common/api';

import 'react-accessible-accordion/dist/fancy-example.css';

import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Alert from "reactstrap/lib/Alert";
import styled, { css } from "styled-components";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';



var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr= [];
var unassign_arr = [];
var data_type = "";

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.getStoreList = this.getStoreList.bind(this);
    this.getSubGroupId=this.getSubGroupId.bind(this);
    this.UnAssign = this.UnAssign.bind(this);
    this.assignedOrdersList = this.assignedOrdersList.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.toggle2New = this.toggle2New.bind(this);

    this.getStationList = this.getStationList.bind(this);
    this.getStationStatus = this.getStationStatus.bind(this);


    this.state = {
      orderdata: [],
      variant_data: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      fillrate_percentage: '',
      tableRowsMap: [],
      sub_group_id: "",
      showGroupErr: false,
      Failedmodal: false,
      showPopup2: false,
      showFilter: false,
      ShowConfirmLoader: false,
      error_message: "",
      stationType: [],
      stationStatus:[],
      unAssignOrder: [],
      assignOrder: [],
      isDisabledSearch: false,
      showConfirmError: false,
      disabledSubBtn: false,
      group_id: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      order: [],
      row_data: [],
      arr_data: [],
      store: [],
      subStore:[],
      distributor:[],
      outlet:[],
      location: [],
      EditModal: false,
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      showTable: false,
      status_type: "1",
      apply: true,
      store_id: "",
      sub_store_id:"",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      request_id: "",
      showUnAssignedOrder: false,
      showFetchDispatchData: false,
      isChecked: false,
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      apply1: true,
      total_value: "",
      total_quantity: "",
      modal: false,
      selectedGroup: "",
      selectedSubGroup:"",
      modal1: false,
      modal2: false,
      modalFailed: false,
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      BeforeConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
    };
  }



  UnAssign(){
      this.setState({
       
        loading_overlay: true,

      })
      const payload = {
        location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
       console.log(response.data.data.unassigned_orders);
       this.setState({
         showUnAssignedOrder: false,
        showAssignedOrder: true,
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders,
        loading_overlay: false,
       })
      })
      .catch(function(error) {});

  }


  assignedOrdersList(){

     const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
       console.log(response.data.data.unassigned_orders);
       this.setState({
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders

       })
      })
      .catch(function(error) {});

  }

   radioChange = (item_code) => {
    addAnalytics('Send To Packing Station', 'Packing Station Radio Change', this.state.data);
    this.setState({
      sub_group_id: item_code,
    });
  };

  AssignData = ()=>{
    this.setState({
      assignLoader: true,
      assignDisabled: true,
      disabledSubBtn: true,
      loading_overlay: true,
      showPopup2: true,
      assignLoader1: true
    })
    console.log("this.state.arr_data", this.state.arr_data);
    var arrayData = this.state.arr_data.filter(
      (item) => item.isChecked === true
    );

    console.log("arrayData", arrayData)

     var arr = [];

    /*for (var i = 0; i < arrayData.length; i++) {
      arr.push(arrayData[i].id);
    }*/

     arr.push(this.state.sub_group_id);

    const payload = {
      location: this.state.selectedLocation,
      sub_grp_ids: arr,
  };
    addAnalytics('Send To Packing Station', 'Confirm Sent to ptl', payload);

    API.post('/picking/createpackingTaskData/v1/', { param: payload })
      .then((response) => {
        //alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          //loading_overlay: true,
          //success_message: response.data.message,
          //failed_message: response.data.message,
          //SuccessConfirmmodal: false
        });
        console.log("response",response.data)
        if(response.data.success == true){
          this.setState({
            success_message: response.data.message,
            loading_overlay: false,
            BeforeConfirmmodal: false,
            assignLoader1: false
          })

          this.toggle2();
          //this.fetchDispatch1();
        }else{
          this.setState({
            failed_message: response.data.message,
            loading_overlay: false,
            BeforeConfirmmodal: false,
            assignLoader1: false
          })
        this.Failedtoggle();
        //return false;
        }
        this.setState({
        SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        assignLoader: false,
        assignDisabled: false,
        createDisabled: false,
        disabledSubBtn:false,
        loading_overlay: false
        })

        
        
        
      })
      .catch(function(error) {});

  }

  UnAssignData(){
    const payload = {
      location: this.state.selectedLocation,
      type: "unassign",
      group_id: this.state.selectedGroup,
      order_id: unassign_arr
  };

API.post('/product/product_master/v1/group/unassign/', { param: payload })
      .then((response) => {
        alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
        });
        
        
      })
      .catch(function(error) {});

  }

  checkedSingle(index, ischecked,orderid) {
    
    var arr=[];
    console.log(this.state.binData);
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.arr_data;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
      
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
      
    }

    console.log(newData);
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
      //binData: newData,
      arr_data: newData
    });

    

    
  }


  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  toggle1() {
    this.setState((prevState) => ({ modal1: !prevState.modal1 }));
  }


  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
  }


  toggle2New() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
    this.fetchDispatch1();
    window.location.reload();
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  Failedtoggle=() => {
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
  }


  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
  }

  BeforeConfirmtoggle = ()=>{
    addAnalytics('Send To Packing Station', 'Clicked Send to ptl', this.state.data);
    this.setState((prevState) => ({
      BeforeConfirmmodal: !prevState.BeforeConfirmmodal,
    }));

  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8090";
    } else {
      url = window.location.hostname+port;
    }
    
    sessionStorage.setItem('PUstore_id', '')
    sessionStorage.setItem('PUpolaris_id', '')
    sessionStorage.setItem('PUstatus_type', '')
    sessionStorage.setItem('PUtask_type_value', '')
    sessionStorage.setItem('PUtask_id', '')

  /* sessionStorage.setItem('store_id', this.state.store_id)
    sessionStorage.setItem('polaris_id', this.state.polaris_id)
    sessionStorage.setItem('status_type', this.state.status_type)
    sessionStorage.setItem('task_type_value', this.state.task_type_value)
    sessionStorage.setItem('task_id', this.state.task_id)
*/

    var cookieUsername = Util.getCookie("token");
    var Location = Util.getCookie("selectedLocation");
    var username = Util.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
        store_id: sessionStorage.getItem('store_id') == "null" ? "" : sessionStorage.getItem('store_id') ,
        polaris_id: sessionStorage.getItem('polaris_id') == "null" ? "" : sessionStorage.getItem('polaris_id') ,
        task_id: sessionStorage.getItem('task_id') == "null" ? "" : sessionStorage.getItem('task_id') ,
        status_type: sessionStorage.getItem('status_type') == "null" || sessionStorage.getItem('status_type') == "" ? "1" : sessionStorage.getItem('status_type') ,
        task_type_value: sessionStorage.getItem('task_type_value') == "null" ? "" : sessionStorage.getItem('task_type_value')

      },
      () => {
        //this.fetchDispatch();
        this.getStoreList();
        this.getStationList();
        this.getSubGroupId();
        this.getStationStatus();
      }
    );
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }



   getStationList() {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/station/type/', { param: payload })
      .then((response) => {

       console.log(response);
        this.setState({ stationType: response.data.data });
      })

      .then(async () => {
        
      });

   
  }

  getStationStatus() {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/station/type/', { param: payload })
      .then((response) => {

       console.log(response);
        this.setState({ stationStatus: response.data.data });
      })

      .then(async () => {
        
      });
  }

  getStoreList() {

      const payload = {
        screen_type: "packing_dashboard_view",
        request_type: "inventory"
  };

API.post('/product/product_master/v1/group/detail/', { param: payload })

      .then((response) => response.data)

      .then((data) => {
       console.log(data);
        this.setState({ store: data.data });
      })

      .then(async () => {
        
      });
  }

  getSubGroupId() {
    
    const payload = {
      screen_type: "packing_dashboard"
  };

API.post('/product/product_master/v1/subgroup/', { param: payload })
    .then((response) => response.data)

    .then((data) => {
     console.log(data);
      this.setState({ subStore: data.data });
    })

    .then(async () => {
      
    });
}

  createGroup() {

    this.SuccessConfirmtoggle();
    
  }


  handleChange1 = (e) => {
    this.setState({
      selectedGroup: e.target.value,
      showGroupErr: false
    });
  };

  changeSubGroup = (e) => {
    this.setState({
      selectedSubGroup: e.target.value,
    });
  };
 

  handleChangeStation = (e) => {
      this.setState({
        selectedStation: e.target.value,
      });
  };



  assembleDispatchData = (dispatchData) => {
    console.log("dispatchData", dispatchData)
    let DispatchData = dispatchData.map((post, index) => {
    
      return {
        //action: post.sub_group_status == 49 ? "" : <input type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle(index,post.isChecked, post.id)}/>,       
        action: <input
              type="radio"
              style={{ width: 18, height: 18 }}
              name="action"
              onChange={() => this.radioChange(post.id)}
            />,
        sub_group_id: post.sub_group,
        order: post.order_qty,
        packing_type: post.packing_type,
        total_value: post.total_val,
        scan_qty: post.scan_qty,
        products: post.product,      
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };


  SearchData(){
    console.log("ARR",this.state.arr_data)
    this.setState({
    loading_overlay: true
    })
    var newArrData = [];
     newArrData = this.state.arr_data.filter(
      (item) => item.party_code == this.state.selectedOutlet || item.distributor_code == this.state.selectedDistributor || item.delivery_center == this.state.selectedLocation || item.outlet_order_no == this.state.selectedOrder
    );
       
    console.log("filterData", newArrData);

    this.setState({
    arr_data: newArrData,
    tableRowsMap: this.assembleDispatchData(newArrData),
    })
  }


  downloadError = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      group_id: this.state.selectedGroup,
      station_type: this.state.selectedStation
  };

API.post('/product/product_master/v1/task/fetch/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);
        this.setState({
          //showFetchDispatchData: true,
          loading: false
        });

        window.location.href= data.data[0]
      })
      .catch(function (error) {});
  };

  
  checkAll() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: false,
      });*/
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: true,
      });*/
    }
  }

  BeforeConfirm = ()=>{

      const payload = {
        sub_group_id: this.state.sub_group_id,
      };

      API.post('/picking/validateSubGroupProducts', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);

        if(data.cycle_count == true && data.putaway == true){
          this.setState({
            error_message: 'Cycle Count and Putaway Processes are in progress for this brand'
          })
        }else if(data.cycle_count == true && data.putaway == false){

          this.setState({
            error_message: 'Cycle Count Processes are in progress for this brand'
          })

        }else if(data.cycle_count == false && data.putaway == true){

          this.setState({
            error_message: 'Putaway Processes are in progress for this brand'
          })

        }else if(data.cycle_count == false && data.putaway == false){

          this.setState({
            error_message: ''
          })

        }

        this.setState({
          fillrate_percentage: data.fill_rate_percentage,
        })
        this.BeforeConfirmtoggle();
        
      })
      .catch(function(error) {});

  }

  fetchDispatch1 = (order_no) => {
    this.setState({
      showPopup2: false
    })

    this.fetchDispatch();
  }
  
   fetchDispatch = (order_no) => {
    var AssignData = [];
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    if(this.state.selectedGroup == "" || this.state.selectedGroup == undefined || this.state.selectedGroup == null){
      this.setState({
        showGroupErr: true
      })
      return false;
    }
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
      location: this.state.selectedLocation,
      group_id: this.state.selectedGroup,
      station_type: this.state.selectedStation,
      sub_group_id:this.state.selectedSubGroup,
  };
  addAnalytics('Send To Packing Station', 'Packing Station Search Filter', payload);

API.post('/product/product_master/v1/order/dashboard/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);
        this.setState({
          showFetchDispatchData: true,
          loading: false
        });

         AssignData = data.data.map((item) => ({
          ...item,
          isChecked: false,
        }));

        if (data.data.length == 0) {
          if(this.state.showPopup2 == false){
            this.toggle();
          }
// alert(data.message)
          this.setState({
            dispatch_status: true,
            showFetchDispatchData: false,
            loading_overlay: false,
            loading: false,
            
          });
          return false;
        }

        this.setState({
          orderData: data.data,
          total_value: data.data.total_value,
          total_quantity: data.data.total_qty,
          arr_data: AssignData,
          tableRowsMap: this.assembleDispatchData(AssignData),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function(error) {});
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { SuccessConfirmmodal, Failedmodal, BeforeConfirmmodal } = this.state;

    const dispatchData = {
      columns: [
        {
          label: 'Action',

          field: "action",
          width: 100,
        },
        {
          label: "Sub Group ID",

          field: "sub_group_id",
          width: 120,
        },
        {
          label: "Order(#)",

          field: "order",
          width: 120,
        },

         {
          label: "Packing Type",

          field: "packing_type",
          width: 120,
        },

        {
          label: "Total Value",

          field: "total_value",
          width: 120,
        },

        {
          label: "Scannable Qty",

          field: "scan_qty",
          width: 120,
        },
        {
          label: "Products(#)",

          field: "products",
          width: 120,
        },

      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={16}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <CardBody style={{ width:1000 ,paddingTop: 10, height: 62, paddingBottom: 0 }}>
            <form className="form form--block" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field">
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChange1}
                  >
                    <option value="">Select Group</option>
                    {
                      this.state.store.length > 0 &&
                      this.state.store.map((store) => {
                        return (
                          <option value={store.id}> {store.name}</option>
                        );
                      })}
                  </select>
                </div>
                 {this.state.showGroupErr &&
                    <span style={{color: 'red', fontSize: 11}}>Please Select Group</span>
                  }
              </div>

               <div
                className="form__form-group col-xl-2"
                style={{marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.changeSubGroup}
                  >
                    <option value="">Select Sub Group</option>
                    {
                      this.state.subStore.length > 0 &&
                      this.state.subStore.map((subStore) => {
                        return (
                          <option value={subStore.name}> {subStore.name}</option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div
                className="form__form-group col-xl-3"
                style={{marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                >
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChangeStation}
                  >
                    <option value="">Select Station Type</option>
                    {
                      this.state.stationType.length > 0 &&
                      this.state.stationType.map((stationType) => {
                        return (
                          <option value={stationType.name}> {stationType.name}</option>
                        );
                      })}
                  </select>
                </div>
              </div>


              <div
                className="form__form-group col-xl-3"
                style={{ marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                >
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChangeStatus}
                  >
                    <option value="">Select Station Status</option>
                    {
                      this.state.stationType.length > 0 &&
                      this.state.stationType.map((stationType) => {
                        return (
                          <option value={stationType.name}> {stationType.name}</option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div className="form__form-group col-xl-2">
              
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch1()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
             
            </form>
          </CardBody>

          {this.state.showFetchDispatchData && (
            <CardBody style={{ marginTop: 2, paddingTop: 0, paddingBottom: 0 }}>
              
             <div
                className="dispatchData stock_check_data style_table"
                style={{ marginTop: 1 }}
              >

               <Button style={{marginBottom: 20, marginTop:10, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" disabled={this.state.disabledSubBtn} onClick={(e) => this.BeforeConfirm()}>Send to PTL</Button>
             
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="390px"
                  displayEntries={false}
                  searching={false}
                  paging={false}
                  striped
                  bordered
                  data={dispatchData}
                />
              </div>        
            </CardBody>
          )}
        </Card>

        <Modal backdrop="static" isOpen={modal} toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-down modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>No Records Available </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
        <Modal backdrop="static" isOpen={modal2} toggle={this.toggle2}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle2}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" ,margin:4}}
            />
            <h4>WH activity initiated, Tasks sent to PTL.
              <h4>Continue with Picking Task Assignment</h4> 
              </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggle2New}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>


         <Modal isOpen={BeforeConfirmmodal} style={{ maxWidth: 585}} backdrop="static" toggle={this.BeforeConfirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.BeforeConfirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr  modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4 style={{ width: '100%' }}>{this.state.error_message}</h4>

            <h4> Fill rate for this task is <strong> {this.state.fillrate_percentage}% </strong> </h4>
            <br/>

             <h5> Do you want to continue sending the data to packing station ? </h5>


          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{ marginRight: 8 }}
              className="modal_cancel"
              onClick={this.BeforeConfirmtoggle}
            >
              Cancel
            </button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData}
              disabled={this.state.assignDisabled1}
            >
              {this.state.assignLoader1 && (
                <i
                  className="fa fa-refresh fa-spin"
                  style={{ marginRight: "5px" }}
                />
              )}
              Confirm
            </Button>
          </ButtonToolbar>
        </Modal>

         

          <Modal backdrop="static" isOpen={Failedmodal} toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
             <span
              className="lnr lnr-thumbs-down modal__title-icon"
              style={{ color: "#ec3e51" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>       
      </Col>
    );
  }
}



export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
